//
//
//
//
//
//

import {watch, computed} from "@nuxtjs/composition-api";
export default {
  name: "SocialMediaSlider",
  components: {},
  props: {
    siteName: String,
    containerId: String,
    productId: [String, Number]
  },
  setup(props) {
    const crl8Filter = computed( () => props.productId ? `productId:'${props.productId}'` : '');
    const crl8Container = computed( () => crl8Filter.value ? 'product' : props.containerId ? props.containerId : 'homepage');

    watch(() => props.siteName, (newVal) => {
      if(newVal) {
        var CRL8_SITENAME = newVal;

        !function(){var e=window.crl8=window.crl8||{},n=!1,i=[];e.ready=function(e){n?e():i.push(e)},e.pixel=e.pixel||function(){e.pixel.q.push(arguments)},e.pixel.q=e.pixel.q||[];var t=window.document,o=t.createElement("script"),c=e.debug||-1!==t.location.search.indexOf("crl8-debug=true")?"js":"min.js";o.async=!0,o.src=t.location.protocol+"//edge.curalate.com/sites/"+CRL8_SITENAME+"/site/latest/site."+c,o.onload=function(){n=!0,i.forEach(function(e){e()})};var r=t.getElementsByTagName("script")[0];r.parentNode.insertBefore(o,r.nextSibling)}();
      }
    }, {immediate: true})

    return {
      crl8Filter,
      crl8Container,
    }
  }
}
